<template>
  <wapi-card>
    <template v-slot:content>
      <div style="height: 215px;">
        <l-map ref="map" :class="'wapi_map__map'">
          <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
          <l-geo-json :geojson="preset.geoJson" :options="geoJsonOptions" />
        </l-map>
      </div>
      <v-list-item three-line class="px-2" style="height: 117px;">
        <v-list-item-content>
          <div class="text-subtitle-2">Имя: {{ preset.name }}</div>
          <v-list-item-title class="text-caption">Id: {{ preset.id }}</v-list-item-title>
          <v-list-item-title>
            <kbd
              class="text-caption"
            >{{ areaInKm(preset.geoJson) }} км² / {{ areaInHa(preset.geoJson) }} га</kbd>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- preset tabs -->
      <v-row>
        <v-col>
          <v-sheet>
            <v-tabs background-color="primary" dark centered>
              <v-tab>WAPI</v-tab>
              <v-tab>GeoJson</v-tab>

              <v-tab-item>
                <v-card class="overflow-x-hidden mx-auto" height="160">
                  <v-card-text class="pa-0">
                    <json-viewer
                      :value="preset.area"
                      copyable
                      boxed
                      expanded
                      :expand-depth="5"
                      sort
                    ></json-viewer>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="overflow-x-hidden mx-auto" height="160">
                  <v-card-text class="pa-0">
                    <json-viewer
                      :value="preset.geoJson"
                      copyable
                      boxed
                      expanded
                      :expand-depth="5"
                      sort
                    ></json-viewer>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-sheet>
        </v-col>
      </v-row>

      <!-- preset buttons -->
      <v-card-actions v-if="isAdmin" class="d-flex justify-end">
        <v-btn v-if="openHandler" text color="primary accent-4" @click="openHandler(preset)">Открыть</v-btn>
        <v-btn v-if="deleteHandler" text color="error" @click="deleteHandler(preset)">Удалить</v-btn>
      </v-card-actions>
      <v-card-actions class="d-flex justify-end">
        <!-- <v-btn
          
          text
          color="primary accent-4"
          @click="report(preset)"
        >
          Отчет EXCEL
        </v-btn>        
        <v-btn
          
          text
          color="primary accent-4"
          @click="report(preset)"
        >
          Отчет EXCEL - реанализ
        </v-btn>-->
      </v-card-actions>
    </template>
  </wapi-card>
</template>

<script>
import WapiCard from "./WapiCard.vue";
import { areaInKm2, areaInHa } from "../helpers/common";
import { getFirstPoint2 } from "../models/helpers/common";

export default {
  name: "wapi-preset-card",
  components: {
    WapiCard
  },
  props: {
    value: {},
    width: Number,
    preset: {}
  },
  methods: {
    deleteHandler() {
      this.$emit("delete-preset", this.preset);
    },
    openHandler() {
      this.$emit("open-preset", this.preset);
    },
    areaInKm(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    areaInHa(geojson) {
      const area = Math.round(areaInHa(geojson.geometry));
      return area;
    },
    async report(preset) {
      await this.$store.dispatch("SET_LOADING", true);
      const point = getFirstPoint2(preset);
      const request = {
        lat: point.latitude,
        lon: point.longitude,
        presetId: preset.id,
        userId: "60d59dac44d7e4281813707a"
      };

      await this.$store.dispatch("FORECAST_REPORT", request);

      await this.$store.dispatch("SET_LOADING", false);
    }
  },
  data() {
    return {
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      showOptions: true,
      grow: false,
      showArrows: false
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    }
  }
};
</script>